<template>
 <div class="background-grey">
   <vue-element-loading :active="loading" :is-full-screen="true"/>
  </div>
</template>

<script>
import {HTTPTICKET,HTTPMentor} from "@/axios.js";
import axios from "axios";
import Swal from 'sweetalert2'

export default {
  name: 'HelloWorld',
  data () {
    return {
      loading:false,
      token:this.$route.params.tokenticket,
    }
  },
  methods:{
      async signout(){
        this.$store.commit("clearlogin");
        window.localStorage.removeItem("ticket");
        console.log('clear')
      },
      async checktokenticket(){
        await this.signout()
        this.loading = true
        var jwt = require('jsonwebtoken');
        var secret = 'dFvsdd125ssE'
        var decoded = jwt.verify(this.token, secret);
        console.log('decoded',decoded)
        let data = ''
        if(decoded.obj.mentorDetail == null){
          data = {
            ...decoded.obj
          }
          console.log('if',data)
        }else{
          let mentorDetail={
            mentorId:decoded.obj.mentorDetail.userId,
            userLevel:decoded.obj.userLevel,
            detailUser:[{
              mentor:true,
              ...decoded.obj
            }]
          }
          data = { 
            mentorDetail:mentorDetail,
            ...decoded.obj
          }
          this.$store.commit('setOpenModalCreate',false)
          console.log('else',data)
        }
        console.log('setUser',data)
        this.$store.commit('setUser',data)
        
        let auth = {
          userId:decoded.obj.userId,
          email:decoded.obj.email,
          name:decoded.obj.name,
          surname:decoded.obj.surname,
          userLevel:decoded.obj.userLevel,
          projectCode:decoded.obj.projectCode,
          typeSystem:decoded.obj.typeSystem
        }
        if(decoded.obj.mentorDetail != null){
           this.$store.commit('setOpenModalCreate',true)
          await HTTPTICKET.post('/api/check/external/user',data).then(res=>{
            console.log('/api/check/external/user',res)
          })
        }else{
          this.$store.commit('setOpenModalCreate',false)
        }
        console.log('auth',auth)
        await HTTPTICKET.post('/api/request/auth',auth).then(res=>{
          console.log('/api/request/auth',res)
          let update = {
            key:'token',
            value:res.data.tokenAuth
          }
           this.$store.commit('updateUser',update)
          let uid = {
            key:'userId',
            value:res.data.obj.userId
          }
          this.$store.commit('updateUser',uid)
        })
        
        this.loading = false
      }
  },
  async mounted(){
      await this.checktokenticket()
      this.$store.commit('checkToken',this.token)
      this.$router.push('/')
  },
}
</script>



// WEBPACK FOOTER //
// src/views/checktoken.vue